export default __webpack_public_path__ + "static/People_Placeholder_1.0@2x-e2830c21b7e135585473b2b5f192ce7c.jpg";